import { useMutation } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { APIError } from '../../../../../utils'
import { ValidateAccountNumberPayload, validateAccountNumber as validateAccountNumberRequest } from '../query-api'

interface UseValidateAccountNumberOptions {
  onError?: (error: APIError, payload: ValidateAccountNumberPayload) => void
  onSuccess?: (isAvailable: boolean, payload: ValidateAccountNumberPayload) => void
}

export const useValidateAccountNumber = (options: UseValidateAccountNumberOptions = {}) => {
  const { onError, onSuccess } = options
  const {
    data: validationResult,
    isLoading: isProcessing,
    isSuccess,
    mutateAsync: validateAccountNumberAsync,
    reset: resetValidation,
    variables: validatedPayload,
  } = useMutation(
    QueryKeys.ValidateAccountNumber,
    (payload: ValidateAccountNumberPayload) => validateAccountNumberRequest(payload).then(({ isFree }) => isFree),
    { onError, onSuccess },
  )

  return {
    isProcessing,
    isSuccess,
    resetValidation,
    validateAccountNumberAsync,
    validatedPayload,
    validationResult,
  }
}
